import { Context, CustomQuery } from '@vue-storefront/core';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default async function customLogout({ client, config }: Context, parms: CustomQuery): Promise<boolean> {

  config.auth.removeToken();

  // Return data from the API
  return true;
}
